<template>
  <div v-if="isExam">
    <keep-alive>
      <component
        :key="exercise.id"
        ref="quiz"
        :is="quizzes[exercise.code]"
        :is-show-explain="isShowExplain"
        :exercise="exercise"
        :is-done="isDone"
        :is-exam="true"
        :is-backtrack="isBacktrack"
        :user-answer="userAnswer"
        @changeOption="changOption"
        @change="change">
      </component>
    </keep-alive>
    <!-- <button @click="next">下一个</button>
    <button @click="prev">上一个</button>
    <button @click="submit">提交</button> -->
  </div>
  <div class="quizes-wrap" v-else>
    <component
      :key="exercise.id"
      :is="quizzes[exercise.code]"
      :is-show-explain="isShowExplain"
      @changeOption="changOption"
      :exercise="exercise"
      :is-done="isDone"
      :is-exam="false"
      @change="change">
    </component>
  </div>
</template>

<script>
import DX from './DX.vue';
import BQ from './BQ.vue';
import ZSD from './ZSD.vue';
import XT from './XT.vue';
import utils from '@/services/utils';
import { mapMutations } from 'vuex';
import { CURRENT_EXERCISE } from '@/store/hk/types';

export default {
  props: {
    exercises: {
      type: Array,
      required: true,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    isBacktrack: {
      type: Number,
      default: 0,
    },
    isShowExplain: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newExercises: [],
      wrongExercises: [],
      deathExercises: [],
      correctExercises: [], // 纠错过的单词 (纠错次数)
      results: [],
      exerciseIndex: 0,
      isDone: false,
      isRight: 0,
      currentAnswer: null,
      quizzes: {
        DX,
        BQ,
        ZSD,
        XT,
      },
      timer: null,
      seconds: 0,
    };
  },
  watch: {
    exercise: {
      handler() {
        if (this.exercise && this.exercise.code === 'ZSD') {
          this.isRight = 1;
          this.isDone = true;
        } else if (this.exercise && this.exercise.code === 'XT') {
          this.isRight = 1;
          this.isDone = false;
        } else {
          this.isRight = 0;
          this.isDone = false;
        }
        this.setCurrentExercise({
          currentExercise: {
            ...this.exercise,
            isComplete: false,
          },
        });
      },
      deep: true,
      immediate: true,
    },
    exerciseIndex() {
      this.$emit('exercise-change', this.exerciseIndex);
    },
  },
  computed: {
    exercise() {
      return this.newExercises[this.exerciseIndex];
    },
    isWrongExercise() {
      return utils.Array.exist(this.wrongExercises, this.exercise, 'id');
    },
    isDeathExercise() {
      return utils.Array.exist(this.deathExercises, this.exercise, 'id');
    },
    userAnswer() {
      return this.isBacktrack ? {
        answer: this.exercise.userAnswer,
      } : null;
    },
  },
  created() {
    this.initNewExercises();
    this.time();
  },
  methods: {
    ...mapMutations({
      setCurrentExercise: CURRENT_EXERCISE,
    }),
    initNewExercises() {
      this.newExercises = this.exercises;
    },
    change(payload) {
      this.exercise.userAnswer = payload.answer;
      if (this.isExam) {
        this.exercise.isRight = payload.isRight;
      }
      this.exercise.isComplete = payload.isComplete;
      this.$nextTick(() => {
        this.isRight = payload.isRight;
      });
      if (this.isExam) {
        this.saveResult();
        this.$emit('result', {
          results: this.results,
        });
      }
      this.$emit('change', {
        ...payload,
      });
      if (this.exercise.code === 'DX') {
        this.$nextTick(() => {
          this.setCurrentExercise({
            currentExercise: utils.clone(this.exercise),
          });
        });
      }
    },
    changOption(payload) {
      this.exercise.formatOptions = payload.formatOptions;
    },
    time() {
      this.timer = setInterval(() => {
        this.seconds += 1;
      }, 1000);
    },
    correctExercise() {
      /* eslint-disable no-lonely-if */
      if (this.isRight) {
        // 是否为错题
        if (!this.isWrongExercise && !this.isDeathExercise && this.exercise.code !== 'XT') {
          this.pushResults(this.isRight);
        }

        if (this.isWrongExercise) {
          // 纠正数 + 1
          this.correctExercises.push(this.exercise);
          // 纠正数是否为1 为1移除错词
          if (utils.Array.getArrRepeatNumber(this.correctExercises, this.exercise, 'id') === 1) {
            if (!this.isDeathExercise) {
              this.pushResults(this.isRight);
            }
            this.removeNewExercise();
          } else {
            this.backwardsInsertExercise();
          }
        } else {
          // 不是错词 直接移除
          this.removeNewExercise();
        }
      } else {
        if (this.isWrongExercise && !this.isDeathExercise) {
          // 判断是错题并且不是死题 防止错误添加
          this.deathExercises.push(this.exercise);
          this.pushResults(this.isRight);
        } else if (!this.isWrongExercise) {
          // 判断是否是错题 防止重复添加
          this.wrongExercises.push(this.exercise);
        }
        this.backwardsInsertExercise();
      }
    },
    // 错题重练 向后插入
    backwardsInsertExercise() {
      if (this.newExercises.length <= 1) {
        const last = Object.assign({}, this.newExercises[0]);
        last.isAgain = true;
        this.newExercises = [last];
        return;
      }

      const [first, ...others] = this.newExercises;
      first.isAgain = true;
      if (this.newExercises.length > 2) {
        this.newExercises = others;
        this.newExercises.splice(2, 0, first);
      } else {
        this.newExercises = [...others, first];
      }
    },
    removeNewExercise() {
      if (this.newExercises.length === 1) {
        this.newExercises = [];
      } else {
        const [, ...others] = this.newExercises;
        this.newExercises = [...others];
      }
    },
    pushResults(isRight) {
      let answer;
      if (this.exercise.userAnswer) {
        answer = this.exercise.userAnswer;
      } else {
        if (this.exercise.code === 'DX') {
          answer = -1;
        } else {
          answer = [];
        }
      }
      this.results.push({
        id: this.exercise.id,
        code: this.exercise.code,
        isRight: isRight || false,
        answer,
      });
    },
    toggleExerciseIndex(index) {
      if (this.exercise.code === 'BQ') {
        this.$refs.quiz.analyze();
      }
      this.exerciseIndex = index;
    },
    next() {
      if (!this.isExam) {
        if (this.isDone) {
          this.correctExercise();
          this.$emit('result', {
            results: this.results,
          });
          this.isDone = false;
        } else {
          this.isDone = true;
        }
      }

      if (this.isExam) {
        if (this.exercise.code === 'BQ') {
          this.$refs.quiz.analyze();
        }
        if (this.exerciseIndex >= this.newExercises.length - 1) {
          utils.message('已经是最后一题了');
        } else {
          this.exerciseIndex += 1;
        }
      }

      if (!this.newExercises.length && !this.isExam) {
        clearInterval(this.timer);
        this.$emit('end', {
          seconds: this.seconds,
        });
      }
    },
    prev() {
      if (this.exerciseIndex <= 0) {
        utils.message('已经是第一题了');
        return;
      }
      if (this.exercise.code === 'BQ') {
        this.$refs.quiz.analyze();
      }
      this.exerciseIndex -= 1;
    },
    saveResult() {
      this.results = this.newExercises.map((exercise) => {
        let answer;
        if (exercise.userAnswer || utils.isNumber(exercise.userAnswer)) {
          answer = exercise.userAnswer;
        } else {
          if (exercise.code === 'DX') {
            answer = -1;
          } else {
            answer = [];
          }
        }
        return {
          id: exercise.id,
          code: exercise.code,
          answer,
          isRight: exercise.isRight || false,
          isComplete: exercise.isComplete || false,
        };
      });
    },
    submit() {
      this.isDone = true;
      clearInterval(this.timer);
      if (this.exercise.code === 'BQ') {
        this.$refs.quiz.analyze();
      }
      this.saveResult();
      this.$emit('submit', {
        results: this.results,
        seconds: this.seconds,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .quizes-wrap {
    height: 100%;
  }
</style>
